import { CLINIC } from "@/constants/clinic";
import DoctorIntro from "@/components/sections/DoctorIntro";
import ClosingCTA from "@/components/sections/ClosingCTA";

export default function AboutPage() {
    return (
        <>
            <section className="relative ihx-warm-surface ihx-grid-overlay">
                <div className="ihx-container py-20 lg:py-28 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
                    <div className="lg:col-span-7">
                        <span className="ihx-eyebrow">About the practice</span>
                        <h1 className="ihx-h-display mt-5">
                            Quiet <span className="ihx-italic">medicine.</span>
                            <br />Loud <span className="ihx-italic">outcomes.</span>
                        </h1>
                        <p className="ihx-lead mt-7 max-w-xl">
                            The practice was built on a single, stubborn idea: that
                            chronic disease isn’t inevitable, and longevity isn’t a
                            commodity. It is engineered — patient by patient, biomarker
                            by biomarker, week after week.
                        </p>
                        <p className="ihx-lead mt-5 max-w-xl">
                            {CLINIC.doctor.fullName} leads a small, deliberate team of
                            clinicians, dietitians and exercise physiologists who share
                            one operating principle: <em className="ihx-italic">measure carefully, prescribe sparingly, follow up relentlessly.</em>
                        </p>
                    </div>
                    <div className="lg:col-span-5 grid grid-cols-2 gap-4">
                        {[
                            { v: "2", l: "Clinics — Chennai & Gurugram" },
                            { v: "12-wk", l: "Reversal protocol cadence" },
                            { v: "40+", l: "Biomarkers tracked per patient" },
                            { v: "24h", l: "Clinical response window" },
                        ].map((s) => (
                            <div key={s.l} className="ihx-card p-6">
                                <div className="font-serif text-[36px] text-[hsl(var(--brand-ink-deep))] leading-none">
                                    {s.v}
                                </div>
                                <div className="text-[12.5px] text-[hsl(var(--ink-muted))] tracking-wide mt-3 leading-snug">
                                    {s.l}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <DoctorIntro />

            <section style={{ backgroundColor: "hsl(var(--bg-chalk))" }}>
                <div className="ihx-container py-20 lg:py-24">
                    <span className="ihx-eyebrow">A quiet philosophy</span>
                    <h2 className="ihx-h-section mt-5 max-w-3xl">
                        We don’t sell wellness. We practise medicine — with the
                        discipline of evidence and the <span className="ihx-italic">empathy of long memory.</span>
                    </h2>
                    <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
                        {[
                            { t: "Evidence first.", d: "Every recommendation is traceable to peer-reviewed data and your individual baseline. If we don’t know, we say so." },
                            { t: "Smallest effective dose.", d: "Of medication, of intervention, of restriction. The goal is freedom, not friction." },
                            { t: "Long horizons.", d: "Reversal happens in months; longevity in decades. We design for the long arc." },
                        ].map((c) => (
                            <div key={c.t} className="ihx-card p-8 md:p-9">
                                <span aria-hidden className="block w-8 h-px bg-[hsl(var(--brand-gold))] mb-5" />
                                <div className="font-serif text-[22px]">{c.t}</div>
                                <p className="text-[14.5px] text-[hsl(var(--ink-soft))] leading-[1.7] mt-3">
                                    {c.d}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <ClosingCTA />
        </>
    );
}
